module.exports = __webpack_public_path__ + "static/media/motic solution2.b45cd765.png";